import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Mail',
  meta: {
    icon: 'fa-envelope',
    expanded: false,
    roles: [Global.ROLE.ADMIN]
  },

  children: [
    {
      name: 'Send Mail',
      meta: {
        label: 'Send Mail',
        roles: [Global.ROLE.ADMIN]
      },
      path: '/mail',
      component: lazyLoading('mailPayment/MailPayment')
    },
    {
      name: 'Mail Template',
      path: '/mailTemplate',
      meta: {
        label: 'Mail Template',
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('mailPayment/MailTemplate')
    },
    {
      name: 'Mail Status',
      path: '/mailStatus',
      meta: {
        label: 'Mail Status',
        roles: [Global.ROLE.ADMIN]
      },
      component: lazyLoading('mailPayment/MailStatus')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/mailPayment.js